import type { PropertyValue } from 'schema-dts';

export const jsonLDProperty = (
  name: string,
  value: unknown
): PropertyValue | null =>
  value !== null ? { '@type': 'PropertyValue', name, value: `${value}` } : null;

export const jsonLD = <T extends object>(data: T) => ({
  'script:ld+json': {
    '@context': 'https://schema.org',
    ...data,
  },
});
